import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react'
import Api from '../../../../../_helpers/Api'

//images
import loader from '../../../../../assets/images/app/loader.svg'
import closeIcon from '../../../../../assets/images/modals/icons/close.png'

//modals
import SuccessModal from '../../../../modals/Success'
import RemoveModal from '../../../../modals/Remove'

//components
import Dropdown from '../../../../app/Dropdown'
import Colors from './partials/Colors'

function CreateEdit(props, ref) {
    //success modal message
    const projectTypeId = props.projectTypeId

    const worker = {
        name: '',
        address: '',
        task_id: null,
        tasks: [],
        project_type_id: projectTypeId,
        task_id: [],
        task_name: []
    }

    const [createEdit, setCreateEdit] = useState({
        overlay: false,
        modal: false,
        types: [],
        clients: [],
        loading: false,
        //edit
        mainLoading: false,
        id: null,
        config: null,
        worker: worker,
        original: worker,
        project_type_id: projectTypeId,
        color: '#eeab2e',
    })

    const form = document.getElementById('edit-form')

    //refs
    const successModalRef = useRef(null)
    const removeModalRef = useRef(null)
    //refs end

    useImperativeHandle(ref, () => ({
        open: (id, config) => handleOpen(id, config),
        close: () => handleClose(),
    }))

    const handleSelectColor = color => {
        setCreateEdit(prev => ({
            ...prev,
            color: color
        }))
    }

    const handleOpen = (id, config) => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            overlay: true,
            id: id,
            config: config,
            project_type_id: projectTypeId,
            mainLoading: id ? true : false,
        }))
        setTimeout(() => {
            setCreateEdit(createEdit => ({
                ...createEdit,
                modal: true,
            }))
        }, 50)

        if (id) getData(id, projectTypeId)
    }

    const getData = (id, projectId) => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            mainLoading: id ? true : false,
        }))

        Api.get(`job/type/find?id=${id}&project_type_id=${projectId}`)
            .then(res => {
                setCreateEdit(createEdit => ({
                    ...createEdit,
                    worker: res.data.items,
                    original: res.data,
                    color: res.data.items.color
                }))
            })
            .finally(() => stopMainLoading())
    }

    const handleClose = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            modal: false,
        }))
        removeModalRef.current.close()
        setTimeout(() => {
            form.reset()
            form.querySelectorAll('select').forEach(i => i.value = 0)

            removeValidations()
            setCreateEdit(createEdit => ({
                ...createEdit,
                overlay: false,
                mainLoading: true,
                id: null,
                worker: worker,
                original: worker
            }))
        }, 100)
    }

    const handleSubmit = e => {
        e.preventDefault()
        let data = new FormData(e.target)

        removeValidations()

        startLoading()

        data.append('id', createEdit.id)
        data.append('color', createEdit.color)

        let url
        if (createEdit.id) url = 'job/type/edit'
        else url = 'job/type/create'

        Api.post(url, data)
            .then(() => {
                successModalRef.current.open()
                props.handleRefreshData()
            })
            .catch(err => {
                let fields = err.response.data.errors

                Object.entries(fields).map(i => {
                    if (i[0]) {
                        let inputs = form.querySelectorAll("[name='" + i[0] + "']")

                        inputs.forEach(i => i.classList.add('validate'))
                    }
                })
            })
            .finally(() => stopLoading())
    }

    const startLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            loading: true,
        }))
    }
    const stopLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            loading: false,
        }))
    }

    const stopMainLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            mainLoading: false,
        }))
    }

    const handleDelete = e => {
        e.preventDefault()
        removeModalRef.current.open()
    }
    const handleRemoveCallback = () => {
        startLoading()
        handleClose()
        Api.post('job/type/delete', {
            id: createEdit.id
        })
            .then(() => {
                stopLoading()
                props.handleRefreshData()
            })
    }

    const handleChangeProject = e => {
        const name = e.target.name
        const val = e.target.value

        setCreateEdit(createEdit => ({
            ...createEdit,
            project_type_id: val
        }))

        getData(createEdit.id, val)

    }

    const removeValidations = () => form.querySelectorAll('.validate').forEach(i => i.classList.remove('validate'))

    return (
        <div className={`${createEdit.overlay ? 'visible' : ''} overlay`}>
            <RemoveModal
                mainMessage="Сигурни ли сте, че искате да изтриете този вид работа?"
                secondaryMessage="Prespa Invest не съхранява изтритите от Вас данни."
                ref={removeModalRef}
                handleRemoveCallback={handleRemoveCallback}
                loading={createEdit.loading}
            />
            <SuccessModal
                mainMessage={createEdit.id ? 'Успешно редактирахте вид работа!' : 'Вид работа е добавен успешно!'}
                secondaryMessage="Може да откриете промените в списъка със задачи."
                ref={successModalRef}
                handleSuccessAction={handleClose}
            />
            <div className="scroller">
                <div className={`${createEdit.modal ? 'show' : ''} box box-small`}>
                    <img src={closeIcon} className="close" onClick={handleClose} />
                    <form id="edit-form" onSubmit={handleSubmit} className="create-task">
                        <h3>
                            {createEdit.config && createEdit.id ? 'Конфигуриране на вид работа' :
                                !createEdit.config && createEdit.id ? 'Редактиране на вид работа' :
                                    'Добавяне на вид работа'
                            }
                        </h3>
                        {createEdit.mainLoading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                {createEdit.config ?
                                    <div className="row">
                                        <div className="col full-width">
                                            <label>
                                                Tип проект
                                        </label>
                                            <select
                                                id="type"
                                                name="project_type_id"
                                                readOnly={projectTypeId != 0}
                                                value={createEdit.project_type_id}
                                                onChange={handleChangeProject}
                                            >
                                                <option value="" selected >Избор</option>
                                                {props.types.map(type =>
                                                    <option key={type.id} value={type.id}>
                                                        {type.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                    </div>

                                    :
                                    ''}

                                {createEdit.config &&
                                    <input hidden name='config' value='1' />
                                }


                                {!createEdit.config && <div className="row">
                                    <div className="col full-width">
                                        <label>
                                            Вид работа
                                    </label>
                                        <input
                                            type="text"
                                            name="name"
                                            defaultValue={createEdit.worker.name}
                                        />
                                    </div>
                                </div>}

                                {createEdit.config && <div className="row">
                                    <div className="col full-width">
                                        <label>
                                            Към видове работа
                                    </label>
                                        <Dropdown
                                            inputIdName="task_id"
                                            url='task/type/all-nopage'
                                            params={{
                                                project_id: ''
                                            }}
                                            multiple={true}
                                            inputClassName="task_id"
                                            multipleInputValues={createEdit.original.task_name}
                                            multipleInputIdValues={createEdit.original.task_id}
                                            renderText={data => {
                                                return <>{data.name}</>
                                            }}
                                        />
                                    </div>
                                </div>}

                                {!createEdit.config && <div className="col">
                                    <label htmlFor="color">
                                        Цвят
                                        </label>
                                    <Colors
                                        value={createEdit.color && createEdit.color ? createEdit.color : '#ffffff'}
                                        selectColor={handleSelectColor}
                                    />
                                </div>}

                                <div className="buttons">
                                    {createEdit.loading ?
                                        <img src={loader} alt="loading" />
                                        :
                                        <>
                                            {createEdit.id && !createEdit.config && <button className="btn-delete" onClick={handleDelete}>
                                                Изтриване
                                        </button>}
                                            <button className="btn-add">
                                                {createEdit.id ?
                                                    'Запазване' :
                                                    'Добавяне'
                                                }
                                            </button>
                                        </>
                                    }
                                </div>
                            </>
                        }
                    </form>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(CreateEdit)